let inject = [
   '$scope',
   '$state',
   '$rootScope',
   'SharedService',
   'ngAuthSettings'
 ];
 
 class CategoriesSynchronousFilterController{
   constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
     this.$state = $state;
     this.$scope = $scope;
     this.ngAuthSettings = ngAuthSettings;
     this.$rootScope = $rootScope;
     this.SharedService = SharedService;
   }
   
 }
 
 CategoriesSynchronousFilterController.$inject = inject;
 
 export default CategoriesSynchronousFilterController;
 
 


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-synchronous-filter/categories-synchronous-filter.controller.js
 **/